<template>
  <table-list-page
    :board-id="boardId"
    :download="false"
    :create="false"
    :multiPrint="false"
    :approval="isApproval"
    :move-project="false"
    :move-detail="false"
    :nav="popupNav"
    :heads="heads"
    :getCol="getCol"
    :prefixFunc="prefixFunc"
    :query-search-mode="false"
    :listTheme="listTheme"
    :minWidth="minWidth"
    @detail="onClickDetail"
  >
    <template #toolRight>
      <vs-button v-if="!readonly" color="secondary" @click="onClickNew" class="mb-4 flex-1 xl:flex-none">신규작성</vs-button>
    </template>
  </table-list-page>
</template>

<script>
import TableListPage from "@/views/list/TableListPage";
import singlePageList from "@/views/boards/single-page/listIndex";
import {listTableMethods, listTableMethods as DataUtil} from "@/util/DataUtil";

export default {
  components: { TableListPage },
  props: {
    isApproval: Boolean,
    readonly: Boolean,
    boardId: [Number, String],
    listTheme: String,
    minWidth: Number,
    nav: Object,
    method: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    heads() {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getHead();
      }
      return [];
    },
    // List.js 에 prefixFunc 이 정의되어 있으면 목록 조회 후처리로 전달 (예: 897 중복 제거)
    prefixFunc() {
      const list = singlePageList[`${this.boardId}_list`];
      return list && list.prefixFunc ? list.prefixFunc : null;
    },
  },
  watch: {
    nav(value) {
      this.popupNav = value;
    },
  },
  data() {
    return {
      printDatas: [],
      isPrint: false,
      popupNav: {
        projectId: this.projectId,
        orderTarget: "created_at",
        orderDirection: "desc",
        parentsPostId: this.$route.params.postId,
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [],
      },
    };
  },
  methods: {
    onClickNew() {
      this.$emit("onClickNew");
    },
    getCol(index, value) {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getCol(index, value, listTableMethods);
      }
      return "";
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content).body;
        return content;
      }
    },

    onClickDetail(data) {
      const proj_id = `${data.projId}`;
      const boardId = `${this.boardId}`;
      const postId = `${data.postId}`;
      const boardSlug = `board-${this.boardId}`;

      this.$router.push({ name: "write|tab", params: { pageType: "write", proj_id, boardId, boardSlug, postId } });
    },
  },
};
</script>
